export default {
    SMS: 'sms',
    EMAIL: 'email'
}